<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9234_68599)">
      <rect x="2.03125"
            y="6.96875"
            width="27.9375"
            height="17.9062"
            rx="2.25"
            fill="url(#paint0_linear_9234_68599)"
      />
      <rect x="2.03125"
            y="6.96875"
            width="27.9375"
            height="17.9062"
            rx="2.25"
            fill="url(#paint1_linear_9234_68599)"
      />
      <rect x="2.03125"
            y="6.96875"
            width="27.9375"
            height="17.9062"
            rx="2.25"
            fill="url(#paint2_linear_9234_68599)"
      />
      <rect x="2.03125"
            y="6.96875"
            width="27.9375"
            height="17.9062"
            rx="2.25"
            fill="url(#paint3_linear_9234_68599)"
      />
      <rect x="2.03125"
            y="6.96875"
            width="27.9375"
            height="17.9062"
            rx="2.25"
            fill="url(#paint4_linear_9234_68599)"
      />
      <path d="M2.03125 12.9688V9.84375H29.9688V12.9688H2.03125Z"
            fill="url(#paint5_linear_9234_68599)"
      />
      <path d="M2.03125 12.9688V9.84375H29.9688V12.9688H2.03125Z"
            fill="url(#paint6_linear_9234_68599)"
      />
      <path d="M2.03125 12.9688V9.84375H29.9688V12.9688H2.03125Z"
            fill="url(#paint7_linear_9234_68599)"
      />
      <path d="M5.56934 19.1826C5.15512 19.1826 4.81934 18.8468 4.81934 18.4326V15.9326C4.81934 15.5184 5.15512 15.1826 5.56934 15.1826H22.8506C23.2648 15.1826 23.6006 15.5184 23.6006 15.9326V18.4326C23.6006 18.8468 23.2648 19.1826 22.8506 19.1826H5.56934Z"
            fill="#359EDA"
      />
      <path d="M5.71875 18.9688C5.30454 18.9688 4.96875 18.633 4.96875 18.2188V15.7188C4.96875 15.3045 5.30454 14.9688 5.71875 14.9688H23C23.4142 14.9688 23.75 15.3045 23.75 15.7188V18.2188C23.75 18.633 23.4142 18.9688 23 18.9688H5.71875Z"
            fill="#E2DDDE"
      />
      <path d="M5.71875 18.9688C5.30454 18.9688 4.96875 18.633 4.96875 18.2188V15.7188C4.96875 15.3045 5.30454 14.9688 5.71875 14.9688H23C23.4142 14.9688 23.75 15.3045 23.75 15.7188V18.2188C23.75 18.633 23.4142 18.9688 23 18.9688H5.71875Z"
            fill="url(#paint8_linear_9234_68599)"
      />
      <path d="M5.71875 18.9688C5.30454 18.9688 4.96875 18.633 4.96875 18.2188V15.7188C4.96875 15.3045 5.30454 14.9688 5.71875 14.9688H23C23.4142 14.9688 23.75 15.3045 23.75 15.7188V18.2188C23.75 18.633 23.4142 18.9688 23 18.9688H5.71875Z"
            fill="url(#paint9_linear_9234_68599)"
      />
      <path d="M5.71875 18.9688C5.30454 18.9688 4.96875 18.633 4.96875 18.2188V15.7188C4.96875 15.3045 5.30454 14.9688 5.71875 14.9688H23C23.4142 14.9688 23.75 15.3045 23.75 15.7188V18.2188C23.75 18.633 23.4142 18.9688 23 18.9688H5.71875Z"
            fill="url(#paint10_linear_9234_68599)"
      />
      <rect x="6.0625"
            y="16.5"
            width="11.8125"
            height="1"
            rx="0.5"
            fill="url(#paint11_linear_9234_68599)"
      />
      <rect x="24.1782"
            y="19.5454"
            width="3.53125"
            height="3.53125"
            rx="0.75"
            fill="#359EDA"
      />
      <rect x="24.375"
            y="19.3125"
            width="3.53125"
            height="3.53125"
            rx="0.75"
            fill="url(#paint12_linear_9234_68599)"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_9234_68599"
                      x1="16"
                      y1="6.96875"
                      x2="16"
                      y2="24.0625"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#57D8F2" />
        <stop offset="1"
              stop-color="#36A3E7"
        />
      </linearGradient>
      <linearGradient id="paint1_linear_9234_68599"
                      x1="16"
                      y1="6.96875"
                      x2="16"
                      y2="24.875"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.941427"
              stop-color="#3086BB"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#3086BB"
        />
      </linearGradient>
      <linearGradient id="paint2_linear_9234_68599"
                      x1="7.73378"
                      y1="20.4157"
                      x2="2.03125"
                      y2="20.4157"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.843326"
              stop-color="#3086BB"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#3086BB"
        />
      </linearGradient>
      <linearGradient id="paint3_linear_9234_68599"
                      x1="16.8708"
                      y1="19.8879"
                      x2="29.9687"
                      y2="19.8879"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.918798"
              stop-color="#45C3FC"
              stop-opacity="0"
        />
        <stop offset="0.963739"
              stop-color="#6BC6FB"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_9234_68599"
                      x1="16.8708"
                      y1="19.8879"
                      x2="16.8708"
                      y2="6.42624"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.904178"
              stop-color="#71FEFF"
              stop-opacity="0"
        />
        <stop offset="0.963739"
              stop-color="#6BF7FF"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_9234_68599"
                      x1="2.03125"
                      y1="12.0625"
                      x2="29.9687"
                      y2="12.0625"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5D476D" />
        <stop offset="0.880313"
              stop-color="#3D3B3B"
        />
      </linearGradient>
      <linearGradient id="paint6_linear_9234_68599"
                      x1="2.03125"
                      y1="11.7936"
                      x2="3.53474"
                      y2="11.7936"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.239027"
              stop-color="#513E5F"
        />
        <stop offset="0.706688"
              stop-color="#513E5F"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint7_linear_9234_68599"
                      x1="29.9688"
                      y1="11.9375"
                      x2="29.0486"
                      y2="11.9375"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.328127"
              stop-color="#515050"
        />
        <stop offset="1"
              stop-color="#474646"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint8_linear_9234_68599"
                      x1="14.9448"
                      y1="17.8547"
                      x2="24.2208"
                      y2="17.8547"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.918798"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
        <stop offset="0.963739"
              stop-color="#FFFFFF"
        />
      </linearGradient>
      <linearGradient id="paint9_linear_9234_68599"
                      x1="14.9448"
                      y1="17.8547"
                      x2="14.9448"
                      y2="19.0772"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.726459"
              stop-color="#D7D0D2"
              stop-opacity="0"
        />
        <stop offset="0.989583"
              stop-color="#D7D0D2"
        />
      </linearGradient>
      <linearGradient id="paint10_linear_9234_68599"
                      x1="14.9448"
                      y1="17.8547"
                      x2="4.96875"
                      y2="17.8547"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.949667"
              stop-color="#D7D0D2"
              stop-opacity="0"
        />
        <stop offset="0.989583"
              stop-color="#D7D0D2"
        />
      </linearGradient>
      <linearGradient id="paint11_linear_9234_68599"
                      x1="6.0625"
                      y1="17"
                      x2="16.9375"
                      y2="17"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A5A0A1" />
        <stop offset="1"
              stop-color="#A6A2A2"
        />
      </linearGradient>
      <linearGradient id="paint12_linear_9234_68599"
                      x1="27.9063"
                      y1="20.7188"
                      x2="25.0313"
                      y2="20.7188"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFE348" />
        <stop offset="0.145672"
              stop-color="#F7D53F"
        />
        <stop offset="1"
              stop-color="#EAC037"
        />
      </linearGradient>
      <clipPath id="clip0_9234_68599">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
